import {path} from "./config.js";
import axios from "axios";

// const ax = require("axios");
const proxyurl = path.proxyPath;
const jsonPath = path.contentPath;
const imgFixpath = path.contentIMGPath;
const resPath = path.resourcesPath;
const resfixPath = path.resourcesFixPath;

function getUrlParams () {
    const url = decodeURIComponent(window.location.href).split("=")[1];
    if (url) {
        return url;
    } else {
        return false;
    }
}

function get(docID, callback) {
    var request = axios.create();
    var req = {};
    var params = [];
    params.push(docID);
    req.params = params;
    req.classname = "viewer";
    req.method = "getDocument";
    return request
        .get(proxyurl, {
            params: {p : JSON.stringify(req)},
            processData: false,
            dataType: "json"
        })
        .then(resp => {
            callback(resp.data)
        })
}

function getContent(folder, fileName, callback=null) {
    var request = axios.create();
    return request
        .get(jsonPath + '?q=' + fileName + '&fld=' + folder, {
            processData: false,
            dataType: "json"
        })
}

function fixResPath(path) {
    if (!path.res) return null; // path.match throws an error if this is undefined
    for (let [index, value] of Object.entries(path)) {
        if (index === "res") {
            //check for old mp3 path
            let m = value.match(/\/resources\/([^/]+)\/([^/]+)\/([^.]+).asp/i);
            if (m != null) {
                path[index] = resfixPath + m[1] + "&type=" + m[2] + "&qid=" + m[3];
            } else {
                path[index] = value.replace(/\/resources\//i, resPath);
            }       
        }   
    }
    return path;
}

function fixImgs(imgTab) {
    for (let [index, value] of Object.entries(imgTab)) {
        if (value != null) {
            if(value.indexOf('src="') > -1) {
                imgTab[index] = value.replace(/src="/gi, 'src="' + imgFixpath);
            }
            else {
                imgTab[index] = value.replace(/src='/gi, "src='" + imgFixpath);
            }
         }
    }
    return imgTab;
}

function fixImgSize() {
    let imageTags = document.images;
    for (let imgTag of imageTags) {
        if (imgTag.src.includes(imgFixpath)) {
            //check if it already has a max-width, if it does do nothing
            imgTag.addEventListener("load", () => {
                //using img.width seems to in some cases provide the wrong value
                if (imgTag.src.includes("pencil")) {
                    imgTag.remove();
                }
                let w = imgTag.naturalWidth + "px";
                imgTag.style.maxWidth = w;
                imgTag.style.width = "100%";
                imgTag.removeAttribute("height");
                imgTag.removeAttribute("width");
            });
        }
    }

}

const nextQuestion = (arr, index) => {
    if (index + 1 === arr.length) {
        return 0
    } 
        return index + 1
}

const previousQuestion = (arr, index) => {
    if (index === 0) {
        return arr.length - 1
    }
        return index - 1
}

const openSummary = () => {
    document.getElementById("summary").hidden = false;
}

const closeSummary = () => {
    document.getElementById("summary").hidden = true;
}

const toggleResourcePlayer = () => {
    if (document.getElementById("resourcePlayer").hidden === false) {
        document.getElementById("resourcePlayer").hidden = true
    } else {
        document.getElementById("resourcePlayer").hidden = false
    }
}

const closeResourcePlayer = () => {
    document.getElementById("resourcePlayer").hidden = true
}

const toggleOptionsMenu = () => {
    if (document.getElementById("options-menu-id").hidden === false) {
        document.getElementById("options-menu-id").hidden = true
    } else {
        document.getElementById("options-menu-id").hidden = false
    }
}

const closeOptionsMenu = () => {
    document.getElementById("options-menu-id").hidden = true
}



const openPrintSelector = () => {
    document.getElementById("print-selector").hidden = false
}

const closePrintSelector = () => {
    document.getElementById("print-selector").hidden = true
}

const openPrintWarning = () => {
    document.getElementById("print-warning").hidden = false
}

const closePrintWarning = () => {
    document.getElementById("print-warning").hidden = true
}
const printSummary = () => {
    return window.print();
}

const desktop = () => {
    const docID = getUrlParams();
    window.open("https://"+docID+".exampro.net", "_blank");
}

const responsiveTables = () => {
    const getTable = document.getElementsByTagName("table");
    for (let table of getTable ) {
        if (getTable.length > 0) {
            const getSeparator = document.getElementsByClassName("contentSeparator");
            const responsiveDiv = document.createElement("div");
            const oneSeparator = getSeparator[0];
            responsiveDiv.className = "table-responsive";
            const tableWidth = table.clientWidth;
            const contentWidth = oneSeparator.clientWidth;
            responsiveDiv.innerHTML = table.outerHTML;
            table.parentNode.insertBefore(responsiveDiv, table);
            if (tableWidth > contentWidth) {
                responsiveDiv.classList.add("table-responsive-shadow")
            }
            table.remove();
        }
    }   
}

const windowScroll = () => {
    if (window.pageYOffset > 47) {
        window.scroll(0, 48)
    } else {
        window.scroll(0, 0)
    }
}

export {
    get,
    getContent,
    nextQuestion,
    previousQuestion,
    openSummary,
    closeSummary,
    toggleOptionsMenu,
    printSummary,
    closeOptionsMenu,
    openPrintSelector,
    closePrintSelector,
    fixImgs,
    fixResPath,
    fixImgSize,
    desktop,
    getUrlParams,
    responsiveTables,
    openPrintWarning,
    closePrintWarning,
    windowScroll,
    toggleResourcePlayer,
    closeResourcePlayer,
};
